export default () => {
  if (!window.app.sentry.enabled) {
    return;
  }

  import(/* webpackChunkName: "sentry" */ '@sentry/browser')
    .then((Sentry) => {
      Sentry.init({
        dsn: window.app.sentry.dsn,
        ignoreErrors: [
          'top.GLOBALS',
          'document.getElementsByClassName.ToString',
          'Multiple lead flow scripts are trying to run',
          'www-widgetapi',
          'Object Not Found Matching Id',
          'The play() request was interrupted by a call to pause()',
          'AbortError: The operation was aborted',
          'Illegal invocation',
          'instantSearchSDKJSBridgeClearHighlight',
          '_reportEvent is not defined',
        ],
        ignoreUrls: [
          /graph\.facebook\.com/i,
          /connect\.facebook\.net\/en_US\/all\.js/i,
          /extensions\//i,
          /^chrome:\/\//i,
          /www-widgetapi/,
          /js\.hsforms\.net/,
        ],
      });

      window.Sentry = Sentry;

      window.app.sentry.loaded = true;

      if (window.capturedErrors.length) {
        window.capturedErrors.forEach((capturedError) => {
          Sentry.captureException(new Error(capturedError[0]), {
            extra: {
              file: capturedError[1],
              lineno: capturedError[2],
              colno: capturedError[3],
            },
          });
        });
      }
    });
};
